import { useContext, useMemo } from "react";
import { useSelector } from "react-redux";
import { useCmsConfig } from "../../Common/hooks/cmsConfig";
import { useUserSelectedSellingCurrency } from "./userSelectedSellingCurrency";
import { RouterContext } from "../../Common/utils/routerContext";
import { Currency } from "../../../Reducers/objects/currency";
import { AppState } from "../../../Reducers/Reducers";

export function useSellingCurrency(): Currency | null {
    const routerContext = useContext(RouterContext);
    const tripCurrency = useSelector((state: AppState) => state.trip.currency);
    const currencies = useSelector((state: AppState) => state.base.currency_list);
    const isInTrip = useMemo(() => {
        return routerContext?.location.pathname.includes(`/${window.url_name}/apps`) &&
            !routerContext?.location.pathname.includes('circuit-b2b-steps') &&
            !routerContext?.location.pathname.includes('circuit-steps');
    }, [routerContext?.location.pathname]);
    const userSelected = useUserSelectedSellingCurrency();
    const cmsConfig = useCmsConfig();

    if (isInTrip) {
        return tripCurrency ?? null;
    }

    let result: Currency | null = userSelected ?? null;

    if (
        cmsConfig?.selling_currencies?.some((item) => {
            return item.id === result?.id;
        })
    ) {
        return result;
    }

    return cmsConfig?.selling_currencies?.[0] ??
        currencies.find((currency) => {
            return currency.iso_code === 'EUR'
        }) ??
        currencies[0] ??
        null;
}